import { useEffect, useState, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const LoadingBar = () => {
    const [progress, setProgress] = useState(0);
    const [isVisible, setIsVisible] = useState(false);
    const location = useLocation();
    const timerRef = useRef(null);

    useEffect(() => {
        // Start loading
        setIsVisible(true);
        setProgress(30);

        timerRef.current = setTimeout(() => setProgress(60), 100);
        const timer2 = setTimeout(() => setProgress(80), 200);
        const timer3 = setTimeout(() => {
            setProgress(100);
            setTimeout(() => setIsVisible(false), 300);
        }, 400);

        return () => {
            clearTimeout(timerRef.current);
            clearTimeout(timer2);
            clearTimeout(timer3);
        };
    }, [location.pathname]);

    if (!isVisible) return null;

    return (
        <div className="fixed top-0 left-0 right-0 z-[9999] h-[3px]">
            <div
                className="h-full bg-gradient-to-r from-primary-500 via-secondary-500 to-accent-500 transition-all duration-300 ease-out"
                style={{ width: `${progress}%` }}
            />
        </div>
    );
};

export default LoadingBar;
